import styled from "styled-components";

const SideMenuWrapper = styled.section`
  box-shadow: rgb(55 86 79) 5px 0px 4px 0px;
  background-color: #252525;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 16px;

  /* ===== Desktop Default ===== */
  width: 100%
  max-width: 320px;
  margin-top:20px;

  /* ===== Image ===== */
  & img {
    width: 220px;
    height: 260px;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 6px 8px 5px 0px #64ffda;
    background-color: #64ffda;
    mix-blend-mode: luminosity;
    transition: all 0.3s ease;
  }

  & img:hover {
    mix-blend-mode: normal;
  }

  /* ===== Text Section ===== */
  & .side-menu__text {
    width: 100%;
    text-align: center;
  }

  & h3 {
    padding-bottom: 12px;
    font-size: 1.2rem;
  }

  & h4 {
    font-size: 1rem;
  }

  & p {
    margin-top: 10px;
    font-size: 0.85rem;
    line-height: 1.5;
    color: white;
  }

  /* =============================
     Large Screens (≥ 1440px)
  ============================== */
  @media (min-width: 1440px) {
    width: 320px;

    & img {
      width: 250px;
      height: 300px;
    }

    & h3 {
      font-size: 1.4rem;
    }

    & p {
      font-size: 0.95rem;
    }
  }

  /* =============================
     Tablets (≤ 1024px)
  ============================== */
  @media (max-width: 1024px) {
    width: 240px;

    & img {
      width: 200px;
      height: 230px;
    }

    & h3 {
      font-size: 1.1rem;
    }
  }

  /* =============================
     Small Tablets / Large Mobiles
     (≤ 768px)
  ============================== */
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 12px;

    & img {
      width: 120px;
      height: 120px;
    }

    & .side-menu__text {
      text-align: left;
      padding-left: 12px;
    }

    & p {
      font-size: 0.8rem;
    }
  }

  /* =============================
     Mobile (≤ 480px)
  ============================== */
  @media (max-width: 480px) {
    padding: 10px;

    & img {
      width: 90px;
      height: 90px;
    }

    & h3 {
      font-size: 1rem;
      padding-bottom: 6px;
    }

    & h4 {
      font-size: 0.8rem;
    }

    & p {
      font-size: 0.75rem;
    }
  }
`;

export default SideMenuWrapper;
